import { createRoot } from "react-dom/client"
import "../src/styles/common.less"
import "../src/styles/designCircle.less"
import App from "./components/app"
const rootElement = document.querySelector("#root") as HTMLElement

createRoot(rootElement).render(<App />)
